import { render, staticRenderFns } from "./ShLinks.vue?vue&type=template&id=62d781b0&scoped=true"
import script from "./ShLinks.vue?vue&type=script&lang=js"
export * from "./ShLinks.vue?vue&type=script&lang=js"
import style0 from "./ShLinks.vue?vue&type=style&index=0&id=62d781b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d781b0",
  null
  
)

export default component.exports